const _getHasSitewideDiscountOnly = (
  promotionCodes: (string | null | undefined)[],
  sitewideDiscount: string,
) => {
  if (!sitewideDiscount) return false;
  return (
    promotionCodes.includes(sitewideDiscount) && promotionCodes.length === 1
  );
};

export default _getHasSitewideDiscountOnly;
